// Goal-setting sanity bounds (owner + safety architecture, 2026-08-08).
// A consumer app must stop helping below the WHO-normal BMI floor: loss
// targets under BMI 18.5 are refused with a suggested minimum, both in the
// onboarding UI and at the API. The upper bound is warn-only — unusual, not
// unsafe in the same way.

export const MIN_HEALTHY_BMI = 18.5;
export const MAX_SENSIBLE_BMI = 32;

/** The lowest loss target the app will accept for a height, in kg. */
export function minHealthyWeightKg(height_cm: number): number {
  return Math.round(MIN_HEALTHY_BMI * Math.pow(height_cm / 100, 2));
}

/** Above this, a gain target gets a "double-check" nudge (never a block). */
export function maxSensibleWeightKg(height_cm: number): number {
  return Math.round(MAX_SENSIBLE_BMI * Math.pow(height_cm / 100, 2));
}
